import React from "react";
import "./TagpayCreate.css";
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import AddTagsComponent from "./Addtags/component";
import ActivateComponent from "./Activate/component";
import RechargeComponent from "./Recharge/component";
import TagpaySeriesComponent from "./CreateTagpaySeries/component";
import uploadsvg from "../../../../assests/uploadsvg.svg";
import Papa from "papaparse";

const TagpayCreateComponent = (props) => {
  const steps = ["Create new series", "Add Tags", "Activate", "Recharge"];
  const navigate = useNavigate();

  const handleClick = () => navigate("/");

  const handleCSVFileUpload = (file) => {
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          const csvData = result.data;
          if (csvData.length > 1) {
            const uidTokenPairs = csvData.slice(1).map((row) => ({
              uid: row[0],
              token: row[1],
            }));
            props.setInputs(uidTokenPairs);
          }
        },
        header: false,
      });
    }
  };

  const renderLeftSideButton = () => {
    if (props.activeStep === 1) {
      return (
        <>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => handleCSVFileUpload(e.target.files[0])}
            style={{ display: "none" }}
            id="fileInput"
          />
          <label htmlFor="fileInput">
            <Button
              variant="contained"
              component="span"
              className="bulk-upload-button primary-button"
            >
              <img src={uploadsvg} alt="Upload" />
              Bulk Upload
            </Button>
          </label>
        </>
      );
    } else if (props.activeStep === 2) {
      return (
        <Button 
          variant="contained" 
          onClick={props.handleSelectAll}
          className="primary-button"
        >
          Select All
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="tagpay-create-container">
      <Sidebar />
      
      <div className="tagpay-create-content">
        <div className="tagpay-create-header">
          <button onClick={handleClick} className="back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h2>Create a New Series</h2>
        </div>

        <div className="tagpay-stepper-container">
          <div className="stepper-controls">
            <Box sx={{ width: '100%', display:"flex", justifyContent:"space-between" }}>
              <Stepper activeStep={props.activeStep}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div className="left-side-button-container">
              {renderLeftSideButton()}
            </div>
            </Box>
           
          </div>

          <div className="tagpay-step-content">
            {props.activeStep === 0 ? (
              <TagpaySeriesComponent
                handleChangeTagSeries={props.handleChangeTagSeries}
                handleCreateTagSeries={props.handleCreateTagSeries}
                createTagSeriesData={props.createTagSeriesData}
                setCreateTagSeriesData={props.setCreateTagSeriesData}
                tagId={props.tagId}
                inputs={props.inputs}
              />
            ) : props.activeStep === 1 ? (
              <AddTagsComponent
                inputs={props.inputs}
                handleInputChange={props.handleInputChange}
                addMoreInputs={props.addMoreInputs}
              />
            ) : props.activeStep === 2 ? (
              <ActivateComponent
                handleActivateTagApi={props.handleActivateTagApi}
                handleActivateInputChange={props.handleActivateInputChange}
                activateTag={props.activateTag}
                setActivateTag={props.setActivateTag}
                addMoreInputsCheckbox={props.addMoreInputsCheckbox}
                activateResponse={props.activateResponse}
                setActivateResponse={props.setActivateResponse}
                handleCheckboxClick={props.handleCheckboxClick}
                selectAll={props.selectAll}
              />
            ) : (
              <RechargeComponent
                activeBtn={props.activeBtn}
                handleAddRechargeBtnClick={props.handleAddRechargeBtnClick}
                handleAddRechargeBtnClick1={props.handleAddRechargeBtnClick1}
                activeBtn1={props.activeBtn1}
                handleChangeRecharge={props.handleChangeRecharge}
                rechargeData={props.rechargeData}
                setActiveBtn={props.setActiveBtn}
                handleResetBalanceChange={props.handleResetBalanceChange}
              />
            )}
          </div>

          <div className="form-actions">
            <Button 
              className="tagpay-secondary-button"
              onClick={props.handleClose}
            >
              Back
            </Button>
            <Button 
              className="tagpay-primary-button" 
              onClick={props.handleNext}
            >
              {props.activeStep === steps.length - 1 ? "Save" : "Save and Continue"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagpayCreateComponent;